<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="w-full h-64 rounded" v-bind:style="{ backgroundImage: 'url(' + imageLink(this.type) + ')' }" style="background-position: center; background-size: cover;">
                    </div>
                    <div class="px-6 py-4">
                        <div class="font-bold text-xl mb-2">
                            <div v-if="type === 'office'">
                                Private Office Space
                            </div>
                            <div v-else-if="type === 'desk'">
                                Hot Desks
                            </div>
                            <div v-else-if="type === 'meeting'">
                                Meeting Rooms
                            </div>
                        </div>

                        <div v-if="type === 'office'">
                            <p class="text-gray-700 text-base">
                            Private Office Space
                            </p>
                        </div>
                        <div v-else-if="type === 'desk'">
                            <p class="text-gray-700 text-base">
                                Hot Desks
                            </p>
                        </div>
                        <div v-else-if="type === 'meeting'">
                            <div class="border-b border-t">
                                <p class="h2">
                                    Board Room
                                </p>
                                <p class="text-gray-700 text-base">
                                    A large board room suited for 10+ people. Includes access to Chromecast for presenting.
                                </p>
                            </div>
                            <div class="border-b">
                                <p class="h2">
                                    Meeting Room
                                </p>
                                <p class="text-gray-700 text-base">
                                    A small meeting room, best suited for 2-5 people.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="inline-flex">
                            <a :href="link(this.type)" class="bg-gray-700 focus:outline-none focus:shadow-outline hover:bg-gray-600 hover:text-gray-200 text-white font-bold py-2 px-4 rounded-l">
                                Check Availability
                            </a>
                            <button class="bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 px-4 rounded-r" @click="$emit('close')">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal",
        props: [
            'type'
        ],
        methods: {
            toggleView: function (el){
                console.log('toggle');
                console.log(el);
            },
            link: function (type) {
                if (type === 'office'){
                    return "https://office.com"
                }else if(type === 'desk'){
                    return "https://desk.com"
                }else if(type === 'meeting'){
                    return "https://meeting.com"
                }
            },
            imageLink: function(type){
                if (type === 'office'){
                    return "/assets/img/office/rooms_2-6.jpg"
                }else if(type === 'desk'){
                    return "/assets/img/shared/rooms_2-5.jpg"
                }else if(type === 'meeting'){
                    return "/assets/img/boardroom/meeting_room-1.jpg"
                }
            }
        }
    }
</script>

<style scoped>

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        overflow-y: scroll;
        height: fit-content;
    }
    @media only screen and (max-width: 600px) {
        .modal-container{
            overflow-y: scroll;
            width: 90%;
            height: 100%;
        }
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>